export class BookDetail {
    public ID: number;
    public HashCode: string;
    public Book_HashCode: string;
    public SchoolID: number;
    public StandardID: number;
    public BoardID: number;
    public MediumID: number;
    public AcademicYearID: number;
    public NoOfBooks: number;
    public BookTitle: string;
    public TotalAmount: string = "";
    public YearID: number;
}